const defaultState = {
  uid: null,
  user: null,
  count: {},
  snack: null,
  modal: null,
  pathname: '',
  snackUrl: null,
  snackType: null,
  isLoading: false,
  modalOpened: null,
  drawerOpened: false,
  restrictedPathname: '',
  refreshingCollection: '',
}


export default function app(state = defaultState, action) {
  switch (action.type) {
    case 'REMOVE_SNACK': return {
      ...state,
      snack: null,
      snackType: null,
    }

    case 'COUNT_DATA': return {
      ...state,
      isLoading: false,
      count: action.count,
    }

    case 'GET_CLIENTS':
    case 'GET_LIST':
    case 'GET_ITEM':
    case 'LOADING': return {
      ...state,
      isLoading: true,
    }

    case 'LOGIN':
    case 'LOGOUT': return {
      ...state,
      uid: null,
      user: null,
      pathname: '/login',
    }

    case 'LOGIN_SUCCESS': return {
      ...state,
      uid: action.uid,
      isLoading: false,
      modalOpened: null,
      user: action.data,
      drawerOpened: false,
      restrictedPathname: '',
      lastUnauthorizedRoute: '',
      // pathname: state.pathname.includes('login') ? '/' : state.pathname,
      pathname: state.restrictedPathname || '/',
    }

    case 'GET_CLIENTS_SUCCESS':
    case 'GET_ITEM_SUCCESS':
    case 'GET_LIST_SUCCESS':
    case 'UNLOAD': return {
      ...state,
      isLoading: false,
    }

    case 'GET_CLIENTS_ERROR':
    case 'GET_ITEM_ERROR':
    case 'GET_LIST_ERROR':
    case 'SNACK_ERROR': return {
      ...state,
      isLoading: false,
      snackType: 'error',
      snack: action.message,
      snackUrl: action.snackUrl,
    }

    case 'LOGIN_ERROR': return {
      ...state,
      isLoading: false,
      snackType: 'error',
      snack: action.message,
    }

    case 'NAVIGATION': return {
      ...state,
      pathname: action.pathname,
      restrictedPathname: action.restrictedPathname || '',
    }

    case 'MODAL': return {
      ...state,
      modal: action.modal,
    }

    case 'SNACK_SUCCESS': return {
      ...state,
      snackType: 'success',
      snack: action.message,
      snackUrl: action.snackUrl,
    }

    case 'OPEN_DRAWER': return {
      ...state,
      drawerOpened: true,
    }

    case 'CLOSE_DRAWER': return {
      ...state,
      drawerOpened: false,
    }

    case 'OPEN_MODAL': return {
      ...state,
      modalOpened: action.modal,
    }

    case 'CLOSE_MODAL': return {
      ...state,
      modalOpened: null,
    }

    case 'REFRESHING': return {
      ...state,
      refreshingCollection: action.collection,
    }

    case 'END_REFRESH': return {
      ...state,
      refreshingCollection: '',
    }

    case 'REFRESH_ERROR': return {
      ...state,
      refreshingCollection: '',
      snackType: 'error',
      snack: 'Impossible de mettre à jour les données',
    }

    default: return state
  }
}
